import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ConstantsService {
  constructor() {   }
  senequaEndpoint = "https://review21.cslbehring.com/api/sequenaSearch";
  SinequaSearchURL = "https://wssearch.cslbehring.com/xrest";
  SinequaSearchProfile = "cslwsCommProfile";
  SinequaSearchCollection = "/CSLBCommercial/kcentra-t/"; 
  
}

